import { format } from 'date-fns';
import { toDate } from 'date-fns-tz';

import { SYSTEM_TIMEZONE } from './time-zone';

export const FORMAT_TIME = 'HH:mm';

interface NormalizeTimeFromDateProps {
  date: Date;
  timeZone?: string;
}

export function normalizeTimeFromDate({
  date,
  timeZone = SYSTEM_TIMEZONE,
}: NormalizeTimeFromDateProps): string {
  return format(toDate(date, { timeZone }), FORMAT_TIME);
}
